export const SET_PROPERTY_DETAILS = 'SET_PROPERTY_DETAILS'
export const SET_LOADING = 'SET_LOADING'
export const SET_FLOOR = 'SET_FLOOR'
export const SET_RECOMMENDED_PROPERTIES = 'SET_RECOMMENDED_PROPERTIES'
export const SET_LOADING_RECOMMENDED_PROPERTIES = 'SET_LOADING_RECOMMENDED_PROPERTIES';
export const CHECK_IF_PROPERTY_ADDED_TO_CART = 'CHECK_IF_PROPERTY_ADDED_TO_CART'